import gql from "graphql-tag";

export const sendVisitReport = gql`
  mutation sendVisitReport($Id: ID!, $AccountId: ID!, $Email: String!, $Notes: String!) {
    VisitReport(Id: $Id, AccountId: $AccountId, Email: $Email, Notes: $Notes)
  }
`;
